export type on_therapy = {
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  bi_completed: string;
  insurance_type: string;
  provider: string;
  treatment_status: string;
  date_of_treatment: null | string;
  date_of_next_treatment: null | string;
  treated_popup: boolean;
  prescription_id: number;
  payer: string;
  re_run_type: string;
  message_icon: boolean;
  indication: string;
  next_steps: string[];
  investigated_at:  string;
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};

export type off_therapy = {
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  insurance_type: string;
  provider: string;
  treatment_status: string;
  color_idx: 1 | 2 | 3 | 4 | 5;
  reason_for_not_treating_patient: null | string;
  bi_completed: null | string;
  treated_popup: boolean;
  prescription_id: number;
  payer: string;
  re_run_type: string;
  message_icon: boolean;
  indication: string;
  next_steps: string[];
  investigated_at:  string;
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};

export type pending_therapy = {
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  insurance_type?: string;
  payer?: string;
  provider: string;
  treatment_status: string;
  color_idx?: 1 | 2 | 3 | 4 | 5;
  treatment_status_color?: 1 | 2 | 3 | 4 | 5;
  bi_submitted: null | string;
  bi_completed: null | string;
  indication?: string;
  note_text?: string;
  confirm_indication: {
    clickable: boolean;
    text: string;
  };
  case_type?: string;
  treated_popup: boolean;
  prescription_id: number;
  reverification: string;
  re_run_type: string;
  message_icon: boolean;
  investigated_at:  string;

  next_steps: string[];
  // investigated_at:  string;
  kam_fam_notes: {
    text: string;
    clickable: boolean;
    type: string;
  };
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};

export type PatientDashboardApiResponse = {
  code: number;
  message: string;
  data: {
    on_treatment: {
      on_therapy: on_therapy[];
      page_count: number;
    };
    off_treatment: {
      off_therapy: off_therapy[];
      page_count: number;
    };
    pending_treatment: {
      pending_therapy: pending_therapy[];
      page_count: number;
    };
    doctor_dropdown: { id: number; name: string }[];
    practice_dropdown: { id: number; name: string }[];
  };
};

export type PatientFiltersState = {
  start_date: string;
  end_date: string;
  case_id: string;
  global_patient_id: string;
  global_doctor_id: string;
  practice_id: string;
  ref_user: string;
  global_patient_external_id: string;
  search_str: string;
  id: string;
  
  role: string;
  pending_therapy_page: number;
  on_therapy_page: number;
  off_therapy_page: number;
  pagination: boolean;
  patient_name:string;
};

export enum PatientFilterStateActions {
  SET_QUERY_PARAMS = "setQueryParams",
  SET_REF_USER = "setRefUser",

  CHANGE_PENDING_THERAPY_PAGE = "changePendingTherapyPage",
  CHANGE_ON_THERAPY_PAGE = "changeOnTherapyPage",
  CHANGE_OFF_THERAPY_PAGE = "changeOffTherapyPage",
  CHANGE_USER_ROLE_AND_ID = "changeUserRoleAndId",
  CHANGE_PAGINATION_BIT = "changePaginationBit",
  RESET_FILTERS = "resetFilters",
}

export type ActionDashboardActionType =
  | {
      type: PatientFilterStateActions.SET_QUERY_PARAMS;
      payload: Omit<
        Omit<
          Omit<PatientFiltersState, "pending_therapy_page">,
          "on_therapy_page"
        >,
        "off_therapy_page"
      >;
    }
  | {
      type: PatientFilterStateActions.SET_REF_USER;
      payload: string;
    }
  | {
      type: PatientFilterStateActions.CHANGE_PENDING_THERAPY_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_ON_THERAPY_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_OFF_THERAPY_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_USER_ROLE_AND_ID;
      payload: { role: string; id: string; ref_user: string };
    }
  | {
      type: PatientFilterStateActions.CHANGE_PAGINATION_BIT;
      payload: boolean;
    }
  | {
      type: PatientFilterStateActions.RESET_FILTERS;
      payload: Partial<PatientFiltersState>;
    };

  export type ExcelSheetCaseProps = {
  "Patient Name ": string;
  "Patient DOB ": string;
  "Case ID": string;
  "Global Patient ID": string;
  "Case Received": string;
  "Case Type": string;
  "Case Completed": string;
  "Scheduled Treatment Date": string;
  "Teatment Date Entered": string;
  "Next Eligible Treatment": string;
  Doctor: string;
  Address: string;
  "Doctor City": string;
  "Doctor State": string;
  "Doctor Zip": string;
  "Case Status": string;
  Indication: string;
  "Diagnosis Codes requested": string;
  "CPT Code": string;
  Qty: string;
  "Primary Insurance": string;
  "Primary Plan Type": string;
  "Secondary Insurance": string;
  "Secondary Plan Type": string;
  "Primary Med Ben Precert Required": string;
  "Primary Pharmacy PA Required": string;
  "Admin code PA required": string;
  "PBM Name": string;
  "Date Transferred to MQC/SP": string;
  "Pharmacy Name": string;
  "External Status Update from Pharmacy": string;
  "Ship Date": string;
  "Tracking Company": string;
  "Tracking Number": string;
  Outcome: string;
  "Status Reason for Not Treating Patient": string;
};

export type ExcelSheetHeader =
  | "Patient Name "
  | "Patient DOB "
  | "Case ID"
  | "Global Patient ID"
  | "Case Received"
  | "Case Type"
  | "Case Completed"
  | "Scheduled Treatment Date"
  | "Teatment Date Entered"
  | "Next Eligible Treatment"
  | "Doctor"
  | "Address"
  | "Doctor City"
  | "Doctor State"
  | "Doctor Zip"
  | "Case Status"
  | "Indication"
  | "Diagnosis Codes requested"
  | "CPT Code"
  | "Qty"
  | "Primary Insurance"
  | "Primary Plan Type"
  | "Secondary Insurance"
  | "Secondary Plan Type"
  | "Primary Med Ben Precert Required"
  | "Primary Pharmacy PA Required"
  | "Admin code PA required"
  | "PBM Name"
  | "Date Transferred to MQC/SP"
  | "Pharmacy Name"
  | "External Status Update from Pharmacy"
  | "Ship Date"
  | "Tracking Company"
  | "Tracking Number"
  | "Outcome"
  | "Status Reason for Not Treating Patient";

